import type { DocumentReference } from 'firebase/firestore'
import { collection, limit as fbLimit, orderBy, query, startAfter, where } from 'firebase/firestore'
import { firestore } from '~/firebaseCore'
import { removePolishLetters } from '~/helpers/text'

export const collectionSupplier = collection(
  firestore,
  'supplier',
)

export function getSuppliersByDeliver(reference: DocumentReference) {
  return query(
    collectionSupplier,
    where('deliverID', '==', reference),
  )
}

export function getSuppliiersByCode(code: number) {
  return query(
    collectionSupplier,
    where('code', '==', `${code}`),
  )
}

export function getSuppliersByCompanyRouteCity(company: DocumentReference, routeRef: DocumentReference, cities: string[]) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('route', '==', routeRef),
    where('place.city', 'in', cities),
  )
}

export function getSuppliersSearcheCity(company: DocumentReference, cities: string[], search: string[]) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where(
      'tags',
      'array-contains-any',
      [
        ...search,
        ...(cities.map(removePolishLetters)),
      ],
    ),
  )
}

export function getSuppliersSubsidyByCompanyRouteCity(company: DocumentReference, cities: string[]) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('subsidy', '!=', null),
    where('place.city', 'in', cities),
  )
}

export function getNotSentNotificationSuppliersByCompanyCity(company: DocumentReference, cities: string[]) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('isPublicOffice', '==', true),
    where('isActive', '==', true),
    where('notificationInfo.notificationCount', '==', 0),
    where('place.city', 'in', cities),
  )
}

export function getNotSentNotificationSuppliersByCompanyCity2(company: DocumentReference, cities: string[]) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('isHomeDelivery', '==', false),
    where('isActive', '==', true),
    where('notificationInfo.notificationCount', '==', 0),
    where('place.city', 'in', cities),
  )
}

export function getNotSentNotificationSuppliersByCompany(company: DocumentReference) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('isPublicOffice', '==', true),
    where('isActive', '==', true),
    where('notificationInfo.notificationCount', '==', 0),
  )
}

export function getNotSentNotificationSuppliersByCompany2(company: DocumentReference) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('isHomeDelivery', '==', false),
    where('isActive', '==', true),
    where('notificationInfo.notificationCount', '==', 0),
  )
}

export function getSuppliersByCompanyRoute(company: DocumentReference, routeRef: DocumentReference) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('route', '==', routeRef),
  )
}

export function getSuppliersSearch(company: DocumentReference, search: string[]) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('tags', 'array-contains-any', search),
  )
}

export function getSuppliersSubsidyByCompanyRoute(company: DocumentReference) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('subsidy', '!=', null),
  )
}

export function getSuppliersSubsidyByRoute(routeRef: DocumentReference) {
  return query(
    collectionSupplier,
    where('route', '==', routeRef),
    orderBy('arrivalTime', 'desc'),
  )
}

export function getSupplierFromHomeDeliveryCity(company: DocumentReference, cities: string[]) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('isHomeDelivery', '==', true),
    where('place.city', 'in', cities),
  )
}

export function getSupplierFromHomeDelivery(company: DocumentReference) {
  return query(
    collectionSupplier,
    where('company', '==', company),
    where('isHomeDelivery', '==', true),
  )
}

export function getSuppliersByCompany(company: DocumentReference, isActive: boolean, limitCount?: number, startAfterDoc?: any) {
  const constraints: any[] = [
    where('company', '==', company),
    where('isActive', '==', isActive),
  ]
  if (typeof limitCount === 'number') {
    constraints.push(fbLimit(limitCount))
  }
  if (startAfterDoc) {
    constraints.push(startAfter(startAfterDoc))
  }
  return query(collectionSupplier, ...constraints)
}

export function getSuppliersByCompanyCity(company: DocumentReference, cities: string[], isActive: boolean, limitCount?: number, startAfterDoc?: any) {
  const constraints: any[] = [
    where('company', '==', company),
    where('place.city', 'in', cities),
    where('isActive', '==', isActive),
  ]
  if (typeof limitCount === 'number') {
    constraints.push(fbLimit(limitCount))
  }
  if (startAfterDoc) {
    constraints.push(startAfter(startAfterDoc))
  }
  return query(collectionSupplier, ...constraints)
}
